import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const InvalidTEAORWarningContent: React.FC = () => {
    const { t } = useTranslation('errors', { keyPrefix: 'ERROR' });

    return (
        <Typography
            dangerouslySetInnerHTML={{
                __html: t(
                    'REGISTRATION_ERRORS.TAX_NUMBER.INVALID_TEAOR.CONTENT'
                ),
            }}
        ></Typography>
    );
};

export default InvalidTEAORWarningContent;
